import { Container, Loader, Modal, Segment, Icon, Transition } from 'semantic-ui-react'
import { Text, MarkupText } from 'preact-i18n'
import { useStore } from '../../store'
import { FrameSourceState } from '@scandit/web-datacapture-core'

const LoadingCameraModal = ({ onHide = () => {} }: { onHide?: () => void }) => {
  const store = useStore()
  const open =
    store.initialOptionsStore.launched.value &&
    store.cameraStore.state.value === FrameSourceState.Off &&
    !store.errorsStore.hasCameraAccessError.value &&
    !store.errorsStore.hasNoCameraAvailableError.value
  return (
    <Transition visible={open} animation="scale" duration={500} onHide={() => onHide()} unmountOnHide>
      <Modal id="loader-modal" basic open={true}>
        <Modal.Content>
          <Container text textAlign="center">
            <Segment inverted style={{ background: 'transparent' }}>
              <Loader size="huge" />
              <Icon fitted name="camera" size="large" color="grey" circular />
            </Segment>
            <div>
              <MarkupText id="info.camera.accessing" />
            </div>
            <Segment textAlign="center" basic>
              <p>
                <Text id="info.camera.accessingMessage" />
              </p>
            </Segment>
          </Container>
        </Modal.Content>
      </Modal>
    </Transition>
  )
}
export default LoadingCameraModal
